export default __webpack_public_path__ + "static/media/verrieres.cd7265b9.png";